import(/* webpackMode: "eager", webpackExports: ["CategoryPage"] */ "/workspace/src/components/category-page.tsx");
